import { useEffect, useState } from 'react';
import { getIdeaToImpactSettings } from '../api';
import { CLOSING_DATE_LABEL, formatClosingDate, isApplicationOpen } from '../config/ideaToImpact';

// How long a fetched answer is reused before the next page asks the API again.
const FRESH_MS = 60 * 1000;
let cached = null;
let inflight = null;

function fetchWindow() {
  if (cached && Date.now() - cached.at < FRESH_MS) return Promise.resolve(cached.value);
  if (!inflight) {
    inflight = getIdeaToImpactSettings()
      .then((res) => {
        const label = formatClosingDate(res.data?.closingDate);
        if (!label || typeof res.data.open !== 'boolean') return null;
        cached = { at: Date.now(), value: { open: res.data.open, label } };
        return cached.value;
      })
      .catch(() => null)
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}

// Test hook: forget the last answer.
export const resetApplicationWindowCache = () => {
  cached = null;
  inflight = null;
};

// The IdeaToImpact application window: { open, label } where label is e.g. '30 November 2026'.
// It starts from the date built into the site, then switches to the one the admin saved as soon
// as the API answers. If the API cannot be reached, the built-in date simply stays.
export default function useApplicationWindow() {
  const [win, setWin] = useState(() =>
    cached ? cached.value : { open: isApplicationOpen(), label: CLOSING_DATE_LABEL }
  );

  useEffect(() => {
    let alive = true;
    fetchWindow().then((value) => {
      if (alive && value) setWin(value);
    });
    return () => {
      alive = false;
    };
  }, []);

  return win;
}
